import { getPath } from '@/router/common'

const baseUrl = {
  title: '基础库',
  path: 'Productlibrary'
}

export default [
  {
    path: getPath('MaterielMainIndex', baseUrl),
    name: 'Productlibrary_MaterielMainIndex',
    component: () => import(/* webpackChunkName: "Productlibrary_MaterielMainIndex" */ '@/views/productlibrary/materielMainIndex/index.vue'),
    meta: {
      title: '物料库'
    }
  },
  {
    path: getPath('ChangecoefficientMainIndex', baseUrl),
    name: 'Productlibrary_ChangecoefficientMainIndex',
    component: () => import(/* webpackChunkName: "Productlibrary_ChangecoefficientMainIndex" */ '@/views/productlibrary/changecoefficientMainIndex/index.vue'),
    meta: {
      title: '转换系数'
    }
  },
  {
    path: getPath('SVolumeMainIndex', baseUrl),
    name: 'Productlibrary_SVolumeMainIndex',
    component: () => import(/* webpackChunkName: "Productlibrary_SVolumeMainIndex" */ '@/views/productlibrary/sVolumeMainIndex/index.vue'),
    meta: {
      title: '体积表'
    }
  },
  {
    path: getPath('SPricelistMainIndex', baseUrl),
    name: 'Productlibrary_SPricelistMainIndex',
    component: () => import(/* webpackChunkName: "Productlibrary_SPricelistMainIndex" */ '@/views/productlibrary/sPricelistMainIndex/index.vue'),
    meta: {
      title: '价格表'
    }
  },
  {
    path: getPath('GzCientIndex', baseUrl),
    name: 'Productlibrary_GzCientIndex',
    component: () => import(/* webpackChunkName: "Productlibrary_GzCientIndex" */ '@/views/productlibrary/gzCientIndex/index.vue'),
    meta: {
      title: '广州计划表'
    }
  },
  {
    path: getPath('HfClientIndex', baseUrl),
    name: 'Productlibrary_HfClientIndex',
    component: () => import(/* webpackChunkName: "Productlibrary_HfClientIndex" */ '@/views/productlibrary/hfClientIndex/index.vue'),
    meta: {
      title: '合肥计划表'
    }
  },
  {
    path: getPath('MaterielImport', baseUrl),
    name: 'Productlibrary_MaterielImport',
    component: () => import(/* webpackChunkName: "Productlibrary_MaterielImport" */ '@/views/productlibrary/materielImport/index.vue'),
    meta: {
      title: '导入物料'
    }
  },
  {
    path: getPath('MaterielAddOrEdit', baseUrl),
    name: 'Productlibrary_MaterielAddOrEdit',
    component: () => import(/* webpackChunkName: "Productlibrary_MaterielAddOrEdit" */ '@/views/productlibrary/materielAddOrEdit/index.vue'),
    meta: {
      title: '新增物料'
    }
  },
  {
    path: getPath('MaterielIndex', baseUrl),
    name: 'Productlibrary_MaterielIndex',
    component: () => import(/* webpackChunkName: "Productlibrary_MaterielIndex" */ '@/views/productlibrary/materielIndex/index.vue'),
    meta: {
      title: '导入运单明细'
    }
  },
  {
    path: getPath('ChangecoefficientIndex', baseUrl),
    name: 'Productlibrary_ChangecoefficientIndex',
    component: () => import(/* webpackChunkName: "Productlibrary_ChangecoefficientIndex" */ '@/views/productlibrary/changecoefficientIndex/index.vue'),
    meta: {
      title: '导入转换系数明细'
    }
  },
  {
    path: getPath('ChangecoefficientImport', baseUrl),
    name: 'Productlibrary_ChangecoefficientImport',
    component: () => import(/* webpackChunkName: "Productlibrary_ChangecoefficientImport" */ '@/views/productlibrary/changecoefficientImport/index.vue'),
    meta: {
      title: '导入转换系数'
    }
  },
  {
    path: getPath('ChangecoefficientAddOrEdit', baseUrl),
    name: 'Productlibrary_ChangecoefficientAddOrEdit',
    component: () => import(/* webpackChunkName: "Productlibrary_ChangecoefficientAddOrEdit" */ '@/views/productlibrary/changecoefficientAddOrEdit/index.vue'),
    meta: {
      title: '新增修改转换系数'
    }
  },
  {
    path: getPath('SVolumeIndex', baseUrl),
    name: 'Productlibrary_SVolumeIndex',
    component: () => import(/* webpackChunkName: "Productlibrary_SVolumeIndex" */ '@/views/productlibrary/sVolumeIndex/index.vue'),
    meta: {
      title: '导入体积明细'
    }
  },
  {
    path: getPath('SVolumeAddOrEdit', baseUrl),
    name: 'Productlibrary_SVolumeAddOrEdit',
    component: () => import(/* webpackChunkName: "Productlibrary_SVolumeAddOrEdit" */ '@/views/productlibrary/sVolumeAddOrEdit/index.vue'),
    meta: {
      title: '新增修改体积'
    }
  },
  {
    path: getPath('SVolumeImport', baseUrl),
    name: 'Productlibrary_SVolumeImport',
    component: () => import(/* webpackChunkName: "Productlibrary_SVolumeImport" */ '@/views/productlibrary/sVolumeImport/index.vue'),
    meta: {
      title: '导入体积'
    }
  },
  {
    path: getPath('SPricelistIndex', baseUrl),
    name: 'Productlibrary_SPricelistIndex',
    component: () => import(/* webpackChunkName: "Productlibrary_SPricelistIndex" */ '@/views/productlibrary/sPricelistIndex/index.vue'),
    meta: {
      title: '导入价格明细'
    }
  },
  {
    path: getPath('SPricelistImport', baseUrl),
    name: 'Productlibrary_SPricelistImport',
    component: () => import(/* webpackChunkName: "Productlibrary_SPricelistImport" */ '@/views/productlibrary/sPricelistImport/index.vue'),
    meta: {
      title: '导入价格'
    }
  },
  {
    path: getPath('SPricelistAddOrEdit', baseUrl),
    name: 'Productlibrary_SPricelistAddOrEdit',
    component: () => import(/* webpackChunkName: "Productlibrary_SPricelistAddOrEdit" */ '@/views/productlibrary/sPricelistAddOrEdit/index.vue'),
    meta: {
      title: '新增修改价格'
    }
  },
  {
    path: getPath('GzCientAddOrEdit', baseUrl),
    name: 'Productlibrary_GzCientAddOrEdit',
    component: () => import(/* webpackChunkName: "Productlibrary_GzCientAddOrEdit" */ '@/views/productlibrary/gzCientAddOrEdit/index.vue'),
    meta: {
      title: '新增广州天津计划表数据'
    }
  },
  {
    path: getPath('GzCientImport', baseUrl),
    name: 'Productlibrary_GzCientImport',
    component: () => import(/* webpackChunkName: "Productlibrary_GzCientImport" */ '@/views/productlibrary/gzCientImport/index.vue'),
    meta: {
      title: '导入广州天津计划表'
    }
  },
  {
    path: getPath('HfClientAddOrEdit', baseUrl),
    name: 'Productlibrary_HfClientAddOrEdit',
    component: () => import(/* webpackChunkName: "Productlibrary_HfClientAddOrEdit" */ '@/views/productlibrary/hfClientAddOrEdit/index.vue'),
    meta: {
      title: '新增合肥计划表数据'
    }
  },
  {
    path: getPath('HfClientImport', baseUrl),
    name: 'Productlibrary_HfClientImport',
    component: () => import(/* webpackChunkName: "Productlibrary_HfClientImport" */ '@/views/productlibrary/hfClientImport/index.vue'),
    meta: {
      title: '导入合肥计划表'
    }
  }
]
